import styles from "./leasecard.module.css";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";
import { User } from "react-feather";

const LeaseCard = ({ item }) => {
    const redirect = useHistory();
    const leaseStatus = item?.lease_status || [];
    const isTenant = Boolean(item?.tenant_id);

    return (
        <Link
            key={item?.id || item?.list_id || item?.apt_id}
            className={`${styles.ProspectCard}`}
            to={isTenant ? "/leases/details/" + item.tenant_id : "#"}
            onClick={(e) => {
                if (!isTenant) e.preventDefault();
            }}
        >
            <div className={`${styles.ProspectCardUnder}`}>
                <div className={`${styles.ProspectCardHeadSection}`}>
                    <div className={`${styles.ProsIMGSec}`}>
                        {isTenant ? (
                            item?.tenant_image !== "" && item?.tenant_image !== undefined ? (
                                <img src={item?.tenant_image} className={`${styles.ProspectCardImg}`} alt="" />
                            ) : (
                                <p>{item?.tenant_initial}</p>
                            )
                        ) : (
                            <div className={`${styles.ProNameIMG}`}>
                                <User />
                            </div>
                        )}
                    </div>

                    <div className={`${styles.HeadConSec}`}>
                        <div className={`${styles.prospectNameActionSec}`}>
                            <p className={`${styles.ProsUserName} ${styles.CallLink}`}>
                                {isTenant
                                    ? `${item?.tenant_name || ""} ${item?.no_of_tenant > 1 ? "+" + (item?.no_of_tenant - 1) : ""}`
                                    : "Vacant"}
                            </p>
                        </div>
                        <p className={`${styles.ProsUserName}`}>
                            {isTenant && Array.isArray(leaseStatus) && (
                                <>
                                    {leaseStatus.indexOf(1) > -1 && leaseStatus.indexOf(6) === -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Success}`}>Verified</span>
                                    )}
                                    {leaseStatus.indexOf(0) > -1 && leaseStatus.indexOf(6) === -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Purple}`}>Not Verified</span>
                                    )}
                                    {leaseStatus.indexOf(4) > -1 && leaseStatus.indexOf(6) === -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Success}`}>Signed</span>
                                    )}
                                    {leaseStatus.indexOf(3) > -1 && leaseStatus.indexOf(6) === -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Success}`}>Tenant Signed</span>
                                    )}
                                    {leaseStatus.indexOf(2) > -1 && leaseStatus.indexOf(6) === -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Purple}`}>Not Signed</span>
                                    )}
                                    {leaseStatus.indexOf(5) > -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Yellow}`}>Expire Soon</span>
                                    )}
                                    {leaseStatus.indexOf(6) > -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Error}`}>Expired</span>
                                    )}
                                    {leaseStatus.indexOf(7) > -1 && (
                                        <span className={`${styles.TagDiv} ${styles.Archive}`}>Archived</span>
                                    )}
                                </>
                            )}
                        </p>
                    </div>
                </div>
                <div className={`${styles.ProspectCardBodySec}`}>
                    <ul>
                        <li>
                            <p className={`${styles.Title}`}>
                                <img src="/static/img/bill-icon.svg" alt="" />
                                Rent :
                            </p>
                            <p className={`${styles.Content}`}>${item?.formatted_rent || "0"}</p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>
                                <img src="/static/img/credit-icon.svg" alt="" />
                                Sec. Deposit :
                            </p>
                            <p className={`${styles.Content}`}>
                                {isTenant ? "$" + (item?.formatted_amount || "0") : "-"}
                            </p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>
                                <img src="/static/img/calendar.svg" alt="" />
                                Lease Term :
                            </p>
                            <p className={`${styles.Content}`}>
                                {isTenant && item?.start_date && item?.end_date
                                    ? `${dayjs(item.start_date).format("L")} - ${dayjs(item.end_date).format("L")}`
                                    : "-"}
                            </p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>
                                <img src="/static/img/home.svg" alt="" />
                                Property :
                            </p>
                            <p
                                className={`${styles.Content} ${styles.Hover}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (item?.property_id) redirect.push("/properties/details/" + item?.property_id);
                                }}
                            >
                                {item?.property_name || "-"}
                            </p>
                        </li>
                        <li>
                            <p className={`${styles.Title}`}>
                                <img src="/static/img/rooms.svg" alt="" />
                                Unit :
                            </p>
                            <p className={`${styles.Content}`}>{item?.apt_no || "-"}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </Link>
    );
};

export default LeaseCard;